module.exports = __webpack_public_path__ + "static/media/icon_down.3eaf6bfc.svg";